export const DEVICE_ID_STORAGE_KEY = "lumids:device-id";

export const normalizeDeviceId = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed;
};

export const getStoredDeviceId = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (!stored) return null;
    return normalizeDeviceId(stored);
  } catch {
    return null;
  }
};

export const storeDeviceId = (value: string): string | null => {
  const normalized = normalizeDeviceId(value);
  if (typeof window === "undefined") return normalized;
  try {
    if (!normalized) {
      window.localStorage.removeItem(DEVICE_ID_STORAGE_KEY);
      return null;
    }
    window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, normalized);
    return normalized;
  } catch {
    return normalized;
  }
};

export const clearStoredDeviceId = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(DEVICE_ID_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const getDeviceIdFromRouteQuery = (query: Record<string, unknown>): string | null => {
  const fromDev = typeof query.dev === "string" ? query.dev : "";
  const fromDeviceId = typeof (query as any).device_id === "string" ? String((query as any).device_id) : "";
  const candidate = (fromDev || fromDeviceId).trim();
  return candidate.length > 0 ? candidate : null;
};

